import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppState } from '../../context/AppStateContext';

// Gates a route subtree to a specific role. Any logged-in user of the wrong
// role gets bounced to their own home instead of the login screen, since
// they ARE authenticated — they just don't belong on this branch.
export const RequireRole = ({ role, children }) => {
  const { isLoggedIn, currentUser, sessionChecked } = useAppState();

  if (!sessionChecked) return null;
  if (!isLoggedIn || currentUser?.role !== role) return <Navigate to="/login" replace />;
  return children;
};
